<!--
 * @Author: wzh
 * @LastEditTime: 2025-05-26 12:00:32
 * @Description: 在线应用
-->
<template>
  <div class="home">
    <header class="head">{{ $t("home.my_app.title") }}</header>
    <a-spin :spinning="loading">
      <a-input-search
        v-model:value="value"
        style="width: 300px; margin-bottom: 20px"
        placeholder="请输入应用名称搜索"
        :loading="btnLoadding"
        @change="getSearch"
        @search="getSearch"
        enter-button
      />
      <div class="my-app" v-if="dataSource.length">
        <div
          v-for="(item, index) in dataSource"
          :key="index"
          class="box"
          @click="jumpUrl(item)"
        >
          <div class="box-flex">
            <img
              width="60"
              height="60"
              :src="
                item.iconBase64 ||
                require('@/assets/images/myapp/app_icon' + (index % 5) + '.png')
              "
            />
            <span>{{ item.appName }}</span>
          </div>
        </div>
      </div>
      <a-empty
        v-else
        :image="simpleImage"
        :description="$t('home.my_app.not_app')"
      />
    </a-spin>
  </div>
</template>

<script>
import { commonAPI } from "@/apis";
import config from "@/config";
import { Empty } from "ant-design-vue";

export default {
  name: "Home",
  data() {
    return {
      dataSource: [],
      loading: false,
      recordObj: {},
      btnLoadding: false,
      value: "",
    };
  },
  beforeCreate() {
    this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
  },
  created() {
    this.getList();
  },
  mounted() {},
  methods: {
    // 获取列表
    async getList() {
      this.loading = true;
      const { code, data } = await commonAPI.getAction("/appList");
      if (code == 0) {
        this.dataSource = data || [];
      } else {
        this.dataSource = [];
      }
      this.loading = false;
    },
    getSearch() {
      if (!this.value) {
        this.getList();
        return;
      }
      this.btnLoadding = true;
      this.dataSource = this.dataSource.filter((item) => {
        return item.appName.includes(this.value);
      });
      this.btnLoadding = false;
    },
    // 跳转外部url
    jumpUrl(item) {
      if (item.status == 2) {
        this.$message.warning(this.$t("home.my_app.tip"));
        return;
      }
      if (item.loginUrl) {
        window.open(item.loginUrl);
      } else {
        this.$message.warning(this.$t("home.my_app.not_app"));
      }
      // if (item.enablePro) {
      // 	window.open(`${config.SERVICES.BASE_URL}/authz/${item.id}`);
      // } else {
      // 	window.open(item.loginUrl);
      // }
    },
  },
};
</script>

<style lang="scss">
.home {
  .head {
    font-size: 18px;
    margin-bottom: 20px;
  }
  .my-app {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 10px;
    .box {
      width: 100%;
      height: 100%;
      background: #fbfbfb;
      border-radius: 6px;
      border: 1px solid #ececec;
      cursor: pointer;
      .box-flex {
        display: flex;
        align-items: center;
        padding: 10px 15px;
      }
      & > div {
        span {
          font-size: 14px;
          color: #040849;
          margin-left: 10px;
          line-height: 16px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
    .box:hover {
      background: #f6f6f6 !important;
    }
  }
}
</style>
